<template>
  <div>
    <NaturalEntityForm 
      ref="naturalEntityFormRef"
      :services="services"
      :naturalEntityId="naturalEntityId"
      :naturalEntity="naturalEntity"
      :isEmployee="isEmployee"
      :employee="employee"
      :isComplement="isComplement"
    />

    <vs-popup fullscreen title="Cadastrar Cônjuge" :active.sync="showNaturalEntityCreateForm">
      <NaturalEntityForm :services="services" :naturalEntityId="null" hide_spouse="true" />
    </vs-popup>
  </div>
</template>

<script>
import NaturalEntityForm from './NaturalEntityForm'

export default {
  components: {
    NaturalEntityForm
  },
  props: {
    naturalEntityId: {
      type: Number,
      default: null
    },
    naturalEntity: {
      type: Object,
      default: null
    },
    services: {
      type: Object,
      default: null
    },
    isEmployee: {
      type: Boolean,
      default: false
    },
    employee: {
      type: Object,
      default: null
    },
    isComplement: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showNaturalEntityCreateForm: false
  }),
  methods: {
    saveNaturalEntity() {
      this.$refs.naturalEntityFormRef.saveNaturalEntity()
    }
  },
  created() {
    const onEscape = e => {
      if (e.keyCode === 27) {
        this.showNaturalEntityCreateForm = false
      }
    }
    document.addEventListener('keydown', onEscape)
  },
  mounted() {
    this.$root.$on('showNaturalEntityCreateForm', () => {
      this.showNaturalEntityCreateForm = true
    })

    this.$root.$on('naturalEntityCreated', naturalEntity => {
      this.$root.$emit('spouseCreated', naturalEntity)
      this.showNaturalEntityCreateForm = false
    })

    this.$root.$on('naturalEntityClosed', () => {
      this.showNaturalEntityCreateForm = false
    })
  }
}
</script>